class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input.field__input');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');

    if (form) {
      form.addEventListener(
        'submit',
        this.onFormSubmit.bind(this)
      );
    }

    if (this.input) {
      this.input.addEventListener(
        'input',
        debounce(() => {
          this.onChange();
        }, 300).bind(this)
      );

      this.input.addEventListener(
        'focus',
        this.onFocus.bind(this)
      );
    }

    this.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.addEventListener(
      'keyup',
      this.onKeyup.bind(this)
    );

    this.addEventListener(
      'keydown',
      this.onKeydown.bind(this)
    );
  }


  getQuery() {
    return this.input
      ? this.input.value.trim()
      : '';
  }


  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {

      /*
       * IMPORTANT:
       * Hide predictive results,
       * but DO NOT remove namah-search-open.
       * Search modal itself is still open.
       */
      this.close(true);

      $('form.search-modal__form .predictive-search-content')
        .css('display', 'none');

      return;
    }

    this.getSearchResults(searchTerm);
  }


  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    ) {
      event.preventDefault();
    }
  }


  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }


  onFocusOut() {
    setTimeout(() => {

      if (!this.contains(document.activeElement)) {
        this.close();
      }

    }, 0);
  }


  onKeyup(event) {

    if (!this.getQuery().length) {

      this.close(true);

      $('form.search-modal__form .predictive-search-content')
        .css('display', 'none');
    }

    switch (event.code) {

      case 'ArrowUp':
        event.preventDefault();
        this.switchOption('up');
        break;

      case 'ArrowDown':
        event.preventDefault();
        this.switchOption('down');
        break;

      case 'Enter':
        this.selectOption();
        break;
    }
  }


  onKeydown(event) {

    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }


  switchOption(direction) {

    if (!this.getAttribute('open')) {
      return;
    }

    const moveUp = direction === 'up';

    const selectedElement =
      this.querySelector('[aria-selected="true"]');

    const allElements =
      this.querySelectorAll('li');

    if (!allElements.length) {
      return;
    }

    let activeElement =
      allElements[0];

    if (moveUp && !selectedElement) {
      return;
    }

    if (this.statusElement) {
      this.statusElement.textContent = '';
    }

    if (!moveUp && selectedElement) {

      activeElement =
        selectedElement.nextElementSibling ||
        allElements[0];

    } else if (moveUp && selectedElement) {

      activeElement =
        selectedElement.previousElementSibling ||
        allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) {
      return;
    }

    activeElement.setAttribute(
      'aria-selected',
      'true'
    );

    if (selectedElement) {

      selectedElement.setAttribute(
        'aria-selected',
        'false'
      );
    }

    this.setLiveRegionText(
      activeElement.textContent
    );

    if (activeElement.id) {

      this.input.setAttribute(
        'aria-activedescendant',
        activeElement.id
      );
    }
  }


  selectOption() {

    const selectedProduct =
      this.querySelector(
        '[aria-selected="true"] a, [aria-selected="true"] button'
      );

    if (selectedProduct) {
      selectedProduct.click();
    }
  }


  getSearchResults(searchTerm) {

    const queryKey = searchTerm;

    this.setLiveRegionLoadingState();


    /*
     * PRODUCTS ONLY
     * No Journal / Article fetch
     */
    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&section_id=predictive-search`
    )

      .then((response) => {

        if (!response.ok) {

          const error =
            new Error(response.status);

          this.close();

          throw error;
        }

        return response.text();
      })

      .then((text) => {

        const parsedHTML =
          new DOMParser().parseFromString(
            text,
            'text/html'
          );

        const productResults =
          parsedHTML.querySelector(
            '#predictive-search-product'
          );

        if (!productResults) {

          this.renderSearchResults(
            '',
            queryKey
          );

          return;
        }

        this.renderSearchResults(
          productResults.innerHTML,
          queryKey
        );
      })

      .catch((error) => {

        this.close();

        console.error(
          'Predictive search error:',
          error
        );
      });
  }


  setLiveRegionLoadingState() {

    this.statusElement =
      this.statusElement ||
      this.querySelector(
        '.predictive-search-status'
      );

    this.loadingText =
      this.loadingText ||
      this.getAttribute(
        'data-loading-text'
      );

    if (this.loadingText) {
      this.setLiveRegionText(
        this.loadingText
      );
    }

    this.setAttribute(
      'loading',
      'true'
    );
  }


  setLiveRegionText(statusText) {

    if (!this.statusElement) {
      return;
    }

    this.statusElement.setAttribute(
      'aria-hidden',
      'false'
    );

    this.statusElement.textContent =
      statusText || '';

    setTimeout(() => {

      if (this.statusElement) {

        this.statusElement.setAttribute(
          'aria-hidden',
          'true'
        );
      }

    }, 1000);
  }


  renderSearchResults(
    resultsMarkup,
    queryKey
  ) {

    if (!this.predictiveSearchResults) {
      return;
    }

    this.predictiveSearchResults.innerHTML =
      resultsMarkup;

    this.setAttribute(
      'results',
      'true'
    );


    /*
     * VIEW ALL = PRODUCTS ONLY
     */
    const url =
      '/search?q=' +
      encodeURIComponent(queryKey) +
      '&type=product';


    $(
      '[data-predictive-search] [data-view-all-product]'
    ).attr(
      'href',
      url
    );


    this.setLiveRegionResults();

    this.open();
  }


  setLiveRegionResults() {

    this.removeAttribute(
      'loading'
    );
  }


  getResultsMaxHeight() {

    const header =
      document.getElementById(
        'shopify-section-header'
      );

    if (!header) {
      return window.innerHeight;
    }

    this.resultsMaxHeight =
      window.innerHeight -
      header.getBoundingClientRect().bottom;

    return this.resultsMaxHeight;
  }


  open() {

    /*
     * Predictive results open.
     * Body class is also controlled by
     * SEARCH MODAL observer below.
     */
    document.body.classList.add(
      'namah-search-open'
    );

    this.setAttribute(
      'open',
      'true'
    );

    if (this.input) {

      this.input.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    $(
      'form.search-modal__form .predictive-search-content'
    ).removeAttr('style');
  }


  close(clearSearchTerm = false) {

    /*
     * DO NOT REMOVE:
     * namah-search-open here.
     *
     * Search popup may still be open
     * even though predictive results
     * are closed / input is empty.
     */

    if (clearSearchTerm) {

      if (this.input) {
        this.input.value = '';
      }

      this.removeAttribute(
        'results'
      );
    }

    const selected =
      this.querySelector(
        '[aria-selected="true"]'
      );

    if (selected) {

      selected.setAttribute(
        'aria-selected',
        'false'
      );
    }

    if (this.input) {

      this.input.setAttribute(
        'aria-activedescendant',
        ''
      );

      this.input.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    this.removeAttribute(
      'open'
    );

    this.removeAttribute(
      'loading'
    );
  }
}


if (!customElements.get('predictive-search')) {

  customElements.define(
    'predictive-search',
    PredictiveSearch
  );
}



/* ==========================================================
   NAMAH SEARCH MODAL STATE FIX
   ==========================================================

   Problem fixed:
   - Desktop search before typing
   - Product page search before typing
   - Homepage mobile search
   - Search after clearing input

   This detects the ACTUAL search popup,
   not only predictive results.
   ========================================================== */


(function () {

  function elementIsVisible(element) {

    if (!element) {
      return false;
    }

    const style =
      window.getComputedStyle(element);

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity || '1') === 0
    ) {
      return false;
    }

    const rect =
      element.getBoundingClientRect();

    if (
      rect.width <= 0 ||
      rect.height <= 0
    ) {
      return false;
    }

    /*
     * Must actually intersect viewport.
     * Important for mobile off-canvas drawers.
     */
    return (
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth
    );
  }



  function isSearchModalOpen() {

    /*
     * Desktop Shopify details/modal state
     */
    const openDetails = document.querySelector(
      `
      .header__search-form details[open],
      details.header__search-form[open],
      details-modal.header__search-form[open],
      .header__search-form[open]
      `
    );

    if (openDetails) {
      return true;
    }


    /*
     * Common active/open drawer classes
     */
    const activeSearch = document.querySelector(
      `
      .search-modal.active,
      .search-modal.open,
      .search-modal.is-open,
      .search-modal.active-search,
      .search-drawer.active,
      .search-drawer.open,
      .search-drawer.is-open,
      .mobile-search.active,
      .mobile-search.open,
      .mobile-search.is-open,
      .drawer-search.active,
      .drawer-search.open,
      .drawer-search.is-open
      `
    );

    if (activeSearch) {
      return true;
    }


    /*
     * Fallback:
     * Check if search interface is visibly
     * occupying the viewport.
     */
    const searchElements =
      document.querySelectorAll(
        `
        .header__search-form .search-modal,
        .search-modal,
        .search-drawer,
        .mobile-search,
        .drawer-search
        `
      );

    for (const element of searchElements) {

      if (elementIsVisible(element)) {
        return true;
      }
    }


    return false;
  }



  function syncSearchLayer() {

    const searchOpen =
      isSearchModalOpen();

    document.body.classList.toggle(
      'namah-search-open',
      searchOpen
    );
  }



  /*
   * Watch Shopify opening / closing
   * desktop AND mobile search.
   */
  const observer =
    new MutationObserver(() => {

      requestAnimationFrame(
        syncSearchLayer
      );

    });



  function startObserver() {

    if (!document.body) {
      return;
    }

    /*
     * Only watch the actual search containers,
     * not the entire page. Same result, far less work.
     */
    const searchTargets = document.querySelectorAll(
      '.header__search-form, .search-modal, .search-drawer, .mobile-search, .drawer-search'
    );

    searchTargets.forEach(function (el) {
      observer.observe(
        el,
        {
          attributes: true,
          attributeFilter: [
            'open',
            'class',
            'style',
            'aria-hidden',
            'aria-expanded'
          ]
        }
      );
    });


    /*
     * Single delayed check after clicks, as a fallback
     * for state changes the observer might miss.
     */
    document.addEventListener(
      'click',
      () => {
        setTimeout(syncSearchLayer, 150);
      },
      true
    );


    /*
     * Check after Escape key.
     */
    document.addEventListener(
      'keydown',
      (event) => {

        if (event.key === 'Escape') {

          setTimeout(
            syncSearchLayer,
            50
          );
        }
      }
    );


    /*
     * Mobile orientation / resize
     */
    window.addEventListener(
      'resize',
      syncSearchLayer
    );


    syncSearchLayer();
  }



  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startObserver
    );

  } else {

    startObserver();
  }

})();